export enum Environment {
  DEV = 'DEV',
  STAGING = 'STAGING',
  PROD = 'PROD',
}
